import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";

export enum LanguageActionTypes {
    SET_LANGUAGE = "SET_LANGUAGE",
    SET_LANGUAGE_LOADING = "SET_LANGUAGE_LOADING",
    SET_ACTIVE_LANGUAGE = "SET_ACTIVE_LANGUAGE",
    SET_DEFAULT_LANGUAGE_CONTENT = "SET_DEFAULT_LANGUAGE_CONTENT",
    SET_LANGUAGE_CONTENT = "SET_LANGUAGE_CONTENT",
    SET_LANGUAGE_INITIALIZED = "SET_LANGUAGE_INITIALIZED"
}

type SetLanguageAction = {
    type: LanguageActionTypes.SET_LANGUAGE,
    payload: { language: LocaleTypes }
};

export const setLanguage = (language: LocaleTypes): SetLanguageAction => ({
    type: LanguageActionTypes.SET_LANGUAGE,
    payload: {
        language
    }
});

type SetLanguageLoadingAction = {
    type: LanguageActionTypes.SET_LANGUAGE_LOADING,
    payload: { isLoading: boolean }
};

export const setLanguageLoading = (isLoading: boolean): SetLanguageLoadingAction => ({
    type: LanguageActionTypes.SET_LANGUAGE_LOADING,
    payload: {
        isLoading
    }
});

type SetActiveLanguageAction = {
    type: LanguageActionTypes.SET_ACTIVE_LANGUAGE,
    payload: { activeLanguage: LocaleTypes }
};

export const setActiveLanguage = (activeLanguage: LocaleTypes): SetActiveLanguageAction => ({
    type: LanguageActionTypes.SET_ACTIVE_LANGUAGE,
    payload: { activeLanguage }
});

type SetLanguageContentAction = {
    type: LanguageActionTypes.SET_LANGUAGE_CONTENT;
    payload: { content: AXNUIContent };
};

export const setLanguageContent = (content: AXNUIContent): SetLanguageContentAction => ({
    type: LanguageActionTypes.SET_LANGUAGE_CONTENT,
    payload: { content }
});

type SetLanguageInitializedAction = {
    type: LanguageActionTypes.SET_LANGUAGE_INITIALIZED;
    payload: { initialized: boolean };
};

export const setLanguageInitialized = (initialized: boolean): SetLanguageInitializedAction => ({
    type: LanguageActionTypes.SET_LANGUAGE_INITIALIZED,
    payload: { initialized }
});

export type LanguageActions =
    SetLanguageAction |
    SetLanguageLoadingAction |
    SetActiveLanguageAction |
    SetLanguageContentAction |
    SetLanguageInitializedAction